<script lang="ts" setup>
import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';
import SvgLoader from '@/utils/SvgLoader.vue';

const props = defineProps<{
  title: string;
  breadcrumbs?: IRouterInfo[];
}>();
</script>

<template>
  <div class="header">
    <div class="header__main">
      <div class="header__title">{{ title }}</div>
      <div v-if="breadcrumbs" class="header__breadcrumbs breadcrumbs">
        <template v-for="(breadcrumb, index) in breadcrumbs" :key="breadcrumb.router">
          <router-link
            class="breadcrumbs__link"
            :class="{ 'breadcrumbs__link--current': index === breadcrumbs.length - 1 }"
            :to="breadcrumb.router"
          >
            {{ breadcrumb.label }}
          </router-link>
          <SvgLoader v-if="index !== breadcrumbs.length - 1" class="breadcrumbs__separator" name="chevronRight" />
        </template>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  padding-top: 16px;
  padding-bottom: 16px;
  font: Noto Sans JP;
  letter-spacing: 0;
  white-space: nowrap;

  &__main {
    display: grid;
    grid-auto-flow: row;
    gap: 16px;
  }

  &__title {
    font-size: 22px;
    font-weight: 700;
    color: $textDefault;
  }
}

.breadcrumbs {
  display: grid;
  grid-auto-flow: column;
  justify-content: start;
  align-items: center;
  gap: 4px;

  &__link {
    font-size: 14px;
    font-weight: 400;
    color: $semanticPrimary;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      text-decoration: underline !important;
    }

    &--current {
      color: $textDefault;
      cursor: default;
      pointer-events: none;
    }
  }

  &__separator {
    display: grid;
    place-content: center;
  }
}
</style>
